import { render, staticRenderFns } from "./MarketsSummary.vue?vue&type=template&id=7bf11ec8&scoped=true&"
import script from "./MarketsSummary.vue?vue&type=script&lang=js&"
export * from "./MarketsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf11ec8",
  null
  
)

export default component.exports